import React from "react";
import PropTypes from "prop-types";
import '../../../../../app/styles/less/components/_collapse-button.less';

const CollapseButton = ({ 
  isCollapsed,
  onToggle,
  expandedLabel = 'Hide',
  collapsedLabel = 'Show',
  className = '',
  testID = '',
  ...buttonProps
}) => {
  const buttonText = isCollapsed ? collapsedLabel : expandedLabel;
  return (
    <button
      type="button"
      className={`btn-default collapse-button ${isCollapsed ? 'collapsed-button-expanded' : ''} ${className}`.trim()}
      onClick={onToggle}
      data-testid={testID}
      aria-expanded={!isCollapsed}
      {...buttonProps}
    >
      <span className="collapse-button__text">{buttonText}</span>
      <i className="fas fa-chevron-down collapse-button__icon" aria-hidden="true" />
   </button>
  );
}

CollapseButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  expandedLabel: PropTypes.string,
  collapsedLabel: PropTypes.string,
  className: PropTypes.string,
  testID: PropTypes.string
};

export default CollapseButton;